const LAST_UPDATED_BLOCK = {
  '@type': '@builder.io/sdk:Element',
  '@version': 2,
  id: 'builder-last-updated-injected',
  component: {
    name: 'LastUpdated',
    options: {},
  },
};

function componentName(block: any): string | undefined {
  return block?.component?.name;
}

function hasLastUpdated(blocks: any[]): boolean {
  return (blocks || []).some(block => {
    if (componentName(block) === 'LastUpdated') return true;
    if (componentName(block) === 'ArticleTag') {
      return (block.children || []).some((child: any) => componentName(child) === 'LastUpdated');
    }
    return false;
  });
}

/**
 * Runtime fallback for Buying Guide pages that do not yet persist LastUpdated
 * in Builder content (pages outside the CSV backfill / duplicate scripts).
 *
 * Nesting rule:
 * - ArticleTag at top-level index 1 -> insert as ArticleTag.children[1]
 * - otherwise -> insert at top-level index 2
 *
 * No-op when LastUpdated is already present (top-level or inside ArticleTag).
 * Mutates `page.data.blocks` in place.
 */
export function injectLastUpdatedBlock<T>(page: T): T {
  const content = page as { data?: { pageGroup?: string; blocks?: any[] } } | null | undefined;
  if (!content?.data) return page;
  if (content.data.pageGroup !== 'Buying Guide') return page;

  if (!Array.isArray(content.data.blocks)) {
    content.data.blocks = [];
  }

  const { blocks } = content.data;
  if (hasLastUpdated(blocks)) {
    return page;
  }

  const articleAtSecond = componentName(blocks[1]) === 'ArticleTag' ? blocks[1] : null;
  if (articleAtSecond) {
    if (!Array.isArray(articleAtSecond.children)) {
      articleAtSecond.children = [];
    }
    const insertAt = Math.min(1, articleAtSecond.children.length);
    articleAtSecond.children.splice(insertAt, 0, { ...LAST_UPDATED_BLOCK });
    return page;
  }

  blocks.splice(2, 0, { ...LAST_UPDATED_BLOCK });
  return page;
}
